module.exports = __webpack_public_path__ + "img/dk_cmr.7f47e9fb.png";